import { render, staticRenderFns } from "./TreatmentDetails.vue?vue&type=template&id=3545ca05&"
import script from "./TreatmentDetails.vue?vue&type=script&lang=js&"
export * from "./TreatmentDetails.vue?vue&type=script&lang=js&"
import style0 from "./TreatmentDetails.vue?vue&type=style&index=0&id=3545ca05&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports